import { Editor, Node, Path, Transforms } from 'slate';

import * as serializer from 'basic-editor-value-serializer';

import { countLayoutAncestors, getParentLayout, wrapInLayout } from './wrap';
import { hostsBlocks } from './insert';

const types = serializer.types;
const layoutUtilities = serializer.utilities.node.layout;

function buildEmptyLayout() {
  return { ...layoutUtilities.buildNode(), children: [] };
}

function removeItemSettings(editor, path) {

  const properties = Node.get(editor, path).properties || {};

  if (typeof properties.layoutItem === 'undefined') {
    return;
  }

  const remaining = { ...properties };
  delete remaining.layoutItem;

  Transforms.setNodes(editor, { properties: remaining }, { at: path });

}

function areSiblingsInOrder(paths) {

  for (let index = 1; index < paths.length; index++) {
    if (Path.equals(paths[index], Path.next(paths[index - 1])) === false) {
      return false;
    }
  }

  return true;

}

function collectNodes(editor, paths) {

  const nodes = [];

  for (let index = 0; index < paths.length; index++) {
    nodes.push(Node.get(editor, paths[index]));
  }

  return nodes;

}

function containsColumns(nodes) {

  for (let index = 0; index < nodes.length; index++) {
    if (nodes[index].type === types.COLUMNS) {
      return true;
    }
  }

  return false;

}

export function isLayoutChild(editor, path) {
  return getParentLayout(editor, path) !== null;
}

export function addItem(editor, layoutPath) {

  const itemPath = layoutPath.concat(Node.get(editor, layoutPath).children.length);

  Transforms.insertNodes(editor, serializer.utilities.node.paragraph.buildNode(), { at: itemPath });
  Transforms.select(editor, Editor.start(editor, itemPath));

}

// The children take the layout's place. Item settings only mean something inside a layout.
export function removeLayoutKeepContent(editor, layoutPath) {

  const keepsItemSettings = isLayoutChild(editor, layoutPath);
  const count = Node.get(editor, layoutPath).children.length;

  Editor.withoutNormalizing(editor, function unwrap() {

    if (keepsItemSettings === false) {
      for (let index = 0; index < count; index++) {
        removeItemSettings(editor, layoutPath.concat(index));
      }
    }

    Transforms.unwrapNodes(editor, { at: layoutPath });

  });

}

// paths: the blocks to wrap in document order, as the drag handle's target paths give them.
export function canWrapInLayout(editor, paths) {

  if (paths.length === 0 || areSiblingsInOrder(paths) === false || hostsBlocks(editor, paths[0]) === false) {
    return false;
  }

  const nodes = collectNodes(editor, paths);

  if (containsColumns(nodes) === true) {
    return false;
  }

  return layoutUtilities.canNest(countLayoutAncestors(editor, paths[0]), layoutUtilities.buildNode({ children: nodes }));

}

// One block hands its item settings to the new layout, which takes its place. Several blocks
// keep their own, since they stay items of a layout.
export function wrapBlocksInLayout(editor, paths) {

  const first = paths[0];

  if (paths.length === 1) {
    wrapInLayout(editor, first, buildEmptyLayout());
    return;
  }

  Editor.withoutNormalizing(editor, function wrap() {

    Transforms.wrapNodes(editor, buildEmptyLayout(), { at: first });

    for (let index = 1; index < paths.length; index++) {
      Transforms.moveNodes(editor, { at: Path.next(first), to: first.concat(index) });
    }

  });

}
